import script from "./LangWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./LangWrapper.vue?vue&type=script&setup=true&lang=js"

import "./LangWrapper.vue?vue&type=style&index=0&id=2eb7f060&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eb7f060"]])

export default __exports__